import poliFoundationRequest from 'src/utils/poliFoundationRequest';

async function scheduledMessageList(account, user, params) {
  const response = await poliFoundationRequest.get(
    `/accounts/${account}/users/${user}/scheduled-messages`, {
      params: params,
    }
  );
  return response.data;
}

export default scheduledMessageList;
